module.exports = __webpack_public_path__ + "static/krannert-94c93bc6f603cb979a9d639f5b0e86f5.png";